export default {
    fields: [
        {
            key: "id",
            label: "#",
            sorter: false,
            filter: false,
            fixed: true,
            _style: "width:10%",
        },
        {
            key: "name",
            label: "name",
            sorter: false,
            filter: true,
            _filter: true,
            _style: "width:20%",
        },
        {
            key: "type",
            label: "type",
            sorter: false,
            filter: true,
            _filter: true,
            _style: "width:20%",
        },
        {
            key: 'options',
            label: '',
            _style: 'width:20%',
            sorter: false,
            filter: false,
            fixed: true,
        }

    ],
    allFields: [],
    items: [],
    order: 'desc',
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
}